import { Row } from "../../../../core/components/Row";
import { StartSection } from "../../../../core/components/StartSection";
import { TextComponent } from "../../../../core/components/TextComponent";
import guiaProveedoresData from "../../../../core/data/db_guia_proveedores.json";
import { CategoriesList } from "../components/CategoriesList";

export const InvitationsAndPaperwork: React.FC = () => {
	const invitationSection = guiaProveedoresData.Invitaciones;
	const invitation = Array.isArray(invitationSection.categorias) ? invitationSection.categorias[0].categorias_detalle : [];

	return (
		<>
			<StartSection
				titulo={invitationSection.titulo}
				backgroundImage={invitationSection.imagen}
				description={invitationSection.descripcion}
			/>
			<Row
				className="w-full gap-2 md:gap-4 p-5 mt-5 bg-white shadow"
				mainAxisAlignment="center"
				crossAxisAlignment="center"
			>
				<TextComponent
					variant="h1"
					className="font-baskerville font-bold text-center text-primarySunset "
				>
					{invitationSection.categorias[0].titulo_principal}
				</TextComponent>
			</Row>
			<main className="self-center w-full sm:w-[40rem] md:w-[90%] xl:w-[60rem] mb-4 sm:mb-8">
				<CategoriesList categories={invitation} />
			</main>
		</>
	);
};
